import React from "react";
import { IoCall } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";

function PrescriptionFooter({ clinicDetails, doctorData }) {
  return (
    <>
      {clinicDetails?.prescription_FooterYN === "Y" ? (
        ""
      ) : clinicDetails?.prescription_FooterYN === "C" ? (
        <div
          dangerouslySetInnerHTML={{
            __html: (() => {
              if (doctorData?.footerDetails) {
                try {
                  return atob(doctorData.footerDetails).replace(
                    /className=/g,
                    "class="
                  );
                } catch (e) {
                  console.error("Error decoding footerDetails:", e);
                  return "";
                }
              }
              return "";
            })(),
          }}
        />
      ) : clinicDetails?.prescription_FooterYN === "N" ? (
        <div
          style={{
            height: `${clinicDetails.prescription_Footer_Space}px`,
          }}
          className="h-auto"
        ></div>
      ) : (
        ""
      )}
      <div className="h-10 my-6">
        <p className="px-2">
          <span className="font-medium">Disclaimer</span>: This prescription has
          been issued via telemedicine based on the information provided by the
          patient. In case of any emergency or worsening symptoms, please
          consult a doctor in person or visit the nearest healthcare facility
          immediately.
        </p>
      </div>
      <div className="flex justify-end">
        <p>&copy; Powered by Doxzon</p>
      </div>
    </>
  );
}

export default PrescriptionFooter;
